export const formatDate = (date: Date) => {
  const optionsDate: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }
  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }

  const formattedDate = new Intl.DateTimeFormat('pl-PL', optionsDate).format(
    date
  )
  const formattedTime = new Intl.DateTimeFormat('pl-PL', optionsTime).format(
    date
  )

  return `${formattedDate}r ${formattedTime}`
}
